export default __webpack_public_path__ + "static/media/place-9.b1cebd4a.jpg";